import type { SxProps } from "@mui/material"

import { DELETE_COLOR, NOTIFICATION_ICONS_OFF } from "@constants/colors"

const menuListItem: SxProps = {
  display: "flex",
  justifyContent: "space-between",
  gap: "1rem",
  width: "100%"
}
const notificationsOffIcon: SxProps = {
  cursor: "pointer",
  color: NOTIFICATION_ICONS_OFF,
  height: "1.1rem"
}

const menuListItemDelete: SxProps = {
  color: DELETE_COLOR
}
const popOverOption: SxProps = {
  padding: 1,
  pr: 9,
  cursor: "pointer",
  "&:hover": {
    background: "#F1F1F1"
  }
}

export default {
  menuListItem,
  notificationsOffIcon,
  menuListItemDelete,
  popOverOption
}
